import { render, staticRenderFns } from "./EnviarAtestado.vue?vue&type=template&id=9a28809e&"
import script from "./EnviarAtestado.vue?vue&type=script&lang=js&"
export * from "./EnviarAtestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports